import { getNewSites } from '@/mocks/sites';
import { categories } from '@/mocks/categories';

export default function LatestSites() {
  const newSites = getNewSites(12);
  const categoryMap = Object.fromEntries(categories.map((c) => [c.slug, c]));

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新收录
            </h2>
            <p className="text-sm text-foreground-600">
              近期新上线的优质站点，发现新鲜内容
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-time-line text-primary-500"></i>
            <span>持续更新中</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {newSites.map((site) => {
            const cat = categoryMap[site.categorySlug];
            return (
              <a
                key={site.id}
                href={site.url}
                target="_blank"
                rel="nofollow noopener"
                className="group p-4 bg-background-100 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-300 cursor-pointer relative"
              >
                <div className="absolute top-3 right-3">
                  <span className="inline-flex items-center gap-1 text-[10px] bg-primary-500 text-background-50 px-1.5 py-0.5 rounded-full font-medium">
                    NEW
                  </span>
                </div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg text-xs">
                    <i className={`${cat?.icon || 'ri-link'}`}></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {site.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {site.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    {site.addedDate}
                  </span>
                  <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded">
                    {cat?.name || site.categorySlug}
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}